module.exports = "<div class=month-navigator> <i ng-if=$ctrl.showIcon class=\"fa fa-calendar\"></i> <div class=month-dropdown> <custom-dropdown empty-display-name=\"''\" item-display-prop=\"'name'\" item-list=$ctrl.months on-item-select=$ctrl.setMonth(item) selected-display=$ctrl.selectedMonth> </custom-dropdown> </div> <div class=year-dropdown> <custom-dropdown empty-display-name=\"''\" item-display-prop=\"'name'\" item-list=$ctrl.years on-item-select=$ctrl.setYear(item) selected-display=$ctrl.selectedYear> </custom-dropdown> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/month-navigator/month-navigator.html
// module id = 353
// module chunks = 0